import React from "react";
import { Button } from "react-bootstrap";
import "../../styles/pages-styles/landing-layout-pages-styles/ContactPage.css";
const ContactPage = () => {
  return (
    <div className="ContactPage-container">
      <h1>Contact us</h1>
      <p>
        If you have any queries, comments or suggestions on how we may improve
        the site, please contact us:
      </p>
      <div className="ContactPage-formitems">
        <label htmlFor="mail">Email:</label>
        <input type="text" name="mail" id="" />
      </div>
      <hr />
      <div className="ContactPage-formitems">
        <label htmlFor="com">Comment:</label>
        <textarea name="" id=""></textarea>
      </div>
      <hr />
      <div>
        <Button>Send Message</Button>
      </div>
      <hr />
      <div>
        <p>
          Alternatively you can e-mail us at{" "}
          <a className="ContactPage-link" href="#">
            contact@passmedicine.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ContactPage;
